var moduleMap = {
	"./AccountCheckupWizard": () => {
		return Promise.all([__webpack_require__.e(19), __webpack_require__.e(440), __webpack_require__.e(932), __webpack_require__.e(682), __webpack_require__.e(822), __webpack_require__.e(301), __webpack_require__.e(689), __webpack_require__.e(901), __webpack_require__.e(343), __webpack_require__.e(658), __webpack_require__.e(659)]).then(() => (() => ((__webpack_require__(9659)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});